
import { Unit } from "@/models/unit";
import { UnitService } from "@/services/unit-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { TranslateResult } from "vue-i18n";
import { DossierConfigService } from "@/services/dossier-config-service";

export default Vue.extend({
	data() {
		return {
			units: [] as Unit[],
			toEditUnit: null as null | Unit,
			generalConfig: DossierConfigService.getGeneralConfig()
		};
	},
	computed: {
		path():IBreadCrumb[]{
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{value: this.$ct("units")}] as IBreadCrumb[];
		},
		editTitle():TranslateResult | string{
			if (!this.toEditUnit) {
				return "";
			}
			if (this.toEditUnit.ID == 0){
				return this.$ct("add-unit");
			}
			return this.$ct("edit-unit");
		},
		langs():string[]{
			return DossierConfigService.getLanguages().LanguageNames;
		},
		selectedLang():string{
			return this.$i18n.locale;
		}
	},
	methods: {
		cancelEdit(){
			this.toEditUnit = null;
		},
		async save(){
			if (!this.toEditUnit) return;
			if (this.toEditUnit.ID == 0){
				await UnitService.postUnit(this.toEditUnit);
			}else{
				await UnitService.putUnit(this.toEditUnit);
			}
			this.fetchUnits();
			this.toEditUnit = null;
		},
		async editUnit(unit:Unit){
			this.toEditUnit = await UnitService.getUnit(unit.ID);
		},
		async deleteUnit(unit:Unit){
			let con = await this.$confirmBuilder(this.$ct("are-you-sure-you-want-to-delete-this-unit")).setWarningTitle().show();
			if (!con) return;
			await UnitService.deleteUnit(unit);
			this.fetchUnits();
		},
		addUnit(){
			this.toEditUnit = new Unit();
		},
		fetchUnits(){
			this.units = UnitService.getUnits();
		},
		async saveGeneralConfig(){
			this.generalConfig = await DossierConfigService.saveGeneralConfig(this.generalConfig);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		}
	},
	async created(){
		this.fetchUnits();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
